import { render, staticRenderFns } from "./IconBubbleMandarin.vue?vue&type=template&id=4524a28d&"
import script from "./IconBubbleMandarin.vue?vue&type=script&lang=js&"
export * from "./IconBubbleMandarin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports